// @flow
import React from 'react';
import type { ClientType } from './flowTypes';

const defaultClient: null | Promise<ClientType> = null;
const ClientContext  = React.createContext(defaultClient);
export default ClientContext;



// WEBPACK FOOTER //
// ./src/application/client/ClientContext.js